import { render, staticRenderFns } from "./FormModalCOAModal.vue?vue&type=template&id=5a908191"
import script from "./FormModalCOAModal.vue?vue&type=script&lang=js"
export * from "./FormModalCOAModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports